// extracted by css-extract-rspack-plugin
export default {"toggle":"CalculatorToggle-module__toggle--Mb4M3","title":"CalculatorToggle-module__title--MdSn8","text":"CalculatorToggle-module__text--LPdJk"};